module.exports = __webpack_public_path__ + "amcharts/images/lens.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/lens.png
// module id = 270
// module chunks = 0